import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
import VeltActivityLogHeaderFilterContentItemIconWireframe from './VeltActivityLogHeaderFilterContentItemIconWireframe/VeltActivityLogHeaderFilterContentItemIconWireframe';
import VeltActivityLogHeaderFilterContentItemLabelWireframe from './VeltActivityLogHeaderFilterContentItemLabelWireframe/VeltActivityLogHeaderFilterContentItemLabelWireframe';
var VeltActivityLogHeaderFilterContentItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-activity-log-header-filter-content-item-wireframe", __assign({}, transformedProps), children));
};
VeltActivityLogHeaderFilterContentItemWireframe.Icon = VeltActivityLogHeaderFilterContentItemIconWireframe;
VeltActivityLogHeaderFilterContentItemWireframe.Label = VeltActivityLogHeaderFilterContentItemLabelWireframe;
export default VeltActivityLogHeaderFilterContentItemWireframe;
